<div class="topDiv" [style.background-color]="backgroundColorScreen">
  <div class="agGridOuterDiv">
    <div>
      <div class="row topRowMargins headerStyle">
        <div class="col-lg-10" style="margin-top: 1%">Migration Tools</div>
        <div class="col-lg-2" style="margin-top: 1%">
          <button
            i18n="@@TMRunButton"
            type="button"
            (click)="refresh()"
            [style.background-color]="buttonColor"
            class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
          >
            Refresh
          </button>
        </div>
      </div>
    </div>
    <div style="display: flex">
      <div class="col-lg-3" style="padding: 0">
        <div>
          <mat-toolbar
            class="agGridtoperDiv card"
            style="
              background: rgb(228 227 230 / 41%);
              border-top: 1px solid #a9a9a9a8;
              border-left: 1px solid #a9a9a9a8;
              border-right: 1px solid #a9a9a9a8;

              margin-top: 0%;
            "
          >
            <label i18n="@@spmsUserReg" class="textColour">Tool Lists</label>
            <span class="example-spacer"></span>
          </mat-toolbar>
        </div>
        <ag-grid-angular
          #Grid
          class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin"
          [columnDefs]="columnDefs"
          [animateRows]="true"
          [defaultColDef]="defaultColDef"
          [suppressPaginationPanel]="true"
          [rowSelection]="rowSelection"
          [rowHeight]="35"
          [headerHeight]="35"
          [enableBrowserTooltips]="true"
          [floatingFiltersHeight]="45"
          [enableRangeSelection]="true"
          [debug]="true"
          (gridReady)="onGridReadyForTools($event)"
          (cellClicked)="retrieveToolData($event)"
          [hidden]="!true"
        >
        </ag-grid-angular>
      </div>

      <div
        class="col-lg-9"
        style="padding: 0px 10px 0px 7px; overflow-x: hidden"
      >
     

        <div>
          <mat-expansion-panel [expanded]="dataExtractorTool"
            style="
              border-left: 1px solid #a9a9a9a8;
              border-top: 1px solid #a9a9a9a8;
              border-right: 1px solid #a9a9a9a8;
              border-radius: 0.8vh 0.8vh 0 0;
              box-shadow: none;
            "
          >
            <mat-expansion-panel-header
              style="
                border-bottom: 1px solid #a9a9a9a8;
                max-height: 50px;
                background: rgb(228 227 230 / 41%);
                flex-basis: auto;
              "
            >
              <mat-panel-title style="flex-basis: auto">
                <label
                  style="font-size: 20px"
                  i18n="@@spmsUserReg"
                  class="textColour"
                  >Tool Description : {{ toolname }}</label
                >
                <span class="example-spacer"></span>
              </mat-panel-title>
              <mat-panel-description> </mat-panel-description>
            </mat-expansion-panel-header>
            <div style="margin-top: 2%; padding-right: 30px; margin-bottom: 1%" *ngIf="!dataExtractorTool">
              <form novalidate [formGroup]="validations_form">
                <div class="row">
                  <div class="col-6" style="text-align: center">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >toolCatalogueId</mat-label
                      >
                      <input
                        [disabled]="true"
                        matInput
                        type="text"
                        formControlName="toolCatalogueId"
                        [(ngModel)]="
                          this.toolDescriptionBinding.toolCatalogueId
                        "
                        maxlength="100"
                        readonly
                        required
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-6" style="text-align: center">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >Tool Name</mat-label
                      >
                      <input
                        matInput
                        type="text"
                        formControlName="toolName"
                        [(ngModel)]="this.toolDescriptionBinding.toolName"
                        maxlength="100"
                        readonly
                        required
                      />
                    </mat-form-field>
                  </div>
                  <div class="col-6" style="text-align: center">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >Endpoint</mat-label
                      >
                      <input
                        matInput
                        type="text"
                        placeholder="Endpoint"
                        formControlName="endpoints"
                        [(ngModel)]="this.toolDescriptionBinding.endpoints"
                        maxlength="100"
                        readonly
                        required
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6" style="text-align: center">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >Input</mat-label
                      >
                      <input
                        matInput
                        type="text"
                        placeholder="Input"
                        formControlName="input"
                        [(ngModel)]="this.toolDescriptionBinding.input"
                        maxlength="100"
                        readonly
                        required
                      />
                    </mat-form-field>
                  </div>
                  <div class="col-6" style="text-align: center">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >Output</mat-label
                      >
                      <input
                        matInput
                        type="text"
                        placeholder="Output"
                        [(ngModel)]="this.toolDescriptionBinding.output"
                        formControlName="output"
                        maxlength="100"
                        readonly
                        required
                      />
                    </mat-form-field>
                  </div>
                </div>

                <div>
                  <mat-form-field appearance="outline">
                    <mat-label i18n="Targetjointno">Tool Description</mat-label>

                    <textarea
                      matInput
                      type="text"
                      formControlName="toolDescription"
                      [(ngModel)]="this.toolDescriptionBinding.toolDescription"
                      readonly
                      [required]
                    >
Tool Description</textarea
                    >
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label i18n="Targetjointno">InstructionToUse</mat-label>

                    <textarea
                      matInput
                      type="text"
                      formControlName="instructionToUse"
                      [(ngModel)]="this.toolDescriptionBinding.instructionToUse"
                      readonly
                      [required]
                    >
InstructionToUse</textarea
                    >
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field appearance="outline">
                    <mat-label i18n="Targetjointno">Usage</mat-label>

                    <textarea
                      matInput
                      type="text"
                      formControlName="usage"
                      [(ngModel)]="this.toolDescriptionBinding.Usage"
                      readonly
                      [required]
                    >
Usage</textarea
                    >
                  </mat-form-field>
                </div>

                <div class="col-5"></div>
              </form>
            </div>

             <!-- Data Extractor Description -->
<div *ngIf="dataExtractorTool" style="padding:20px;background:#fff;">
  <form novalidate [formGroup]="FormValidCaseAudit">

<div class="row">

    <!-- LEFT -->
    <div class="col-lg-6">

        <!-- Source CSV -->
        <div style="display:flex;margin-bottom:10px;">
            <mat-form-field appearance="outline" style="width:100%">
                <mat-label>Source CSV File</mat-label>
                <input
                matInput
                readonly
                formControlName="sourceFileName"
                [(ngModel)]="FormValidCaseAudit.controls.sourceFileName.value">

              <mat-error *ngIf="FormValidCaseAudit.get('sourceFileName').invalid && (FormValidCaseAudit.get('sourceFileName').dirty || FormValidCaseAudit.get('sourceFileName').touched)">
                Source CSV File is required
              </mat-error>
            </mat-form-field>

            <div class="file-field" style="width:20%">
                <a class="btn-floating btn-sm m-0 float-right">
                    <em class="fas fa-paperclip mt-0"
                        style="text-rendering:auto;color:black"></em>

                    <input
                        type="file"
                        accept=".csv"
                        (change)="uploadExcelFile($event,'source')">
                </a>
            </div>
        </div>

        <!-- Template -->
        <div style="display:flex;margin-bottom:10px;">
            <mat-form-field appearance="outline" style="width:100%">
                <mat-label>Template File</mat-label>
                <input
                matInput
                readonly
                formControlName="templateFileName"
                [(ngModel)]="FormValidCaseAudit.controls.templateFileName.value">

                <mat-error *ngIf="FormValidCaseAudit.get('templateFileName').invalid &&
              (FormValidCaseAudit.get('templateFileName').dirty ||
               FormValidCaseAudit.get('templateFileName').touched)">
              Template File is required
            </mat-error>
            </mat-form-field>

            <div class="file-field" style="width:20%">
                <a class="btn-floating btn-sm m-0 float-right">
                    <em class="fas fa-paperclip mt-0"
                        style="text-rendering:auto;color:black"></em>

                    <input
                        type="file"
                        accept=".xls,.xlsx"
                        (change)="uploadExcelFile($event,'template')">
                </a>
            </div>
        </div>

        <!-- Split Count -->
        <mat-form-field appearance="outline" style="width:100%">
            <mat-label>Split Count</mat-label>
            <input
              matInput
              type="number"
              formControlName="splitCount"
              placeholder="Enter Split Count">

            <mat-error *ngIf="FormValidCaseAudit.get('splitCount').invalid &&
              (FormValidCaseAudit.get('splitCount').dirty ||
               FormValidCaseAudit.get('splitCount').touched)">
              Split Count is required
            </mat-error>

            <mat-error *ngIf="FormValidCaseAudit.get('splitCount')?.hasError('max')">
    Split Count cannot be greater than 1000.
</mat-error>

<mat-error *ngIf="FormValidCaseAudit.get('splitCount')?.hasError('min')">
    Split Count must be greater than 0.
</mat-error>
        </mat-form-field>

        <!-- Username -->
        <mat-form-field appearance="outline" style="width:100%">
            <mat-label>New Run Username (Comma Separated)</mat-label>
            <input
              matInput
              type="text"
              formControlName="userName"
              placeholder="user1,user2,user3">

            <mat-error *ngIf="FormValidCaseAudit.get('userName').invalid &&
              (FormValidCaseAudit.get('userName').dirty ||
               FormValidCaseAudit.get('userName').touched)">
              New Run Username is required
            </mat-error>
        </mat-form-field>

        <!-- Failed Username -->
        <mat-form-field appearance="outline" style="width:100%">
            <mat-label>Failed Run Username(Comma Separated)</mat-label>
            <input
              matInput
              type="text"
              formControlName="failedUserName"
              placeholder="user1,user2,user3">

            <mat-error *ngIf="FormValidCaseAudit.get('failedUserName').invalid &&
              (FormValidCaseAudit.get('failedUserName').dirty ||
               FormValidCaseAudit.get('failedUserName').touched)">
              Failed Run Username is required
            </mat-error>
        </mat-form-field>

        <!-- Max Retry -->
        <mat-form-field appearance="outline" style="width:100%">
            <mat-label>Max Retry</mat-label>
            <input
              matInput
              type="number"
              formControlName="maxRetry"
              placeholder="Enter Max Retry">

            <mat-error *ngIf="FormValidCaseAudit.get('maxRetry').invalid &&
              (FormValidCaseAudit.get('maxRetry').dirty ||
               FormValidCaseAudit.get('maxRetry').touched)">
              Max Retry is required
            </mat-error>

            <mat-error *ngIf="FormValidCaseAudit.get('maxRetry')?.hasError('max')">
    Max Retry cannot be greater than 5.
</mat-error>

<mat-error *ngIf="FormValidCaseAudit.get('maxRetry')?.hasError('min')">
    Max Retry must be greater than 0.
</mat-error>
        </mat-form-field>

        <mat-checkbox formControlName="validationRequired" style="margin-bottom:12px; display:block;">
          Validation Required?
        </mat-checkbox>

        <!-- Upload Button -->
        <div style="margin-top:10px;text-align:left;">

          <!-- <app-common-button
          label="Upload"
          title="Upload"
          [buttonId]="1111"
          width="110px"
          [critical]="false"
          (clicked)="uploadCaseAuditFile()"
           style="margin-left: 6px;margin-right:6px;"
          > -->
          <!-- </app-common-button> -->

  

  <button
    i18n="@@TMRunButton"
    type="button"
    (click)="uploadCaseAuditFile()" title="Upload"
    [style.background-color]="buttonColor"
    class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
    
  > Upload
  </button>

            <app-common-button
          label="Username Config"
          title="Username Config"
          [buttonId]="1111"
          width="110px"
          [critical]="false"
          (clicked)="openUsernameConfigDialog()"
           style="margin-left: 6px;margin-right:6px;"
          >
          </app-common-button>
          
        </div>

    </div>



    <!-- RIGHT -->
<div
    class="col-lg-6"
    style="
        padding-left:30px;
        border-left:1px solid #d6d6d6;
        min-height:100%;
    ">

    <!-- Header -->
    <div style="
        display:flex;
        justify-content:space-between;
        align-items:center;
        margin-bottom:18px;
        padding:0 10px;
    ">

        <span style="font-size:20px;font-weight:600;">
            Execution Dashboard
        </span>

        <button
            mat-icon-button
            (click)="toggleDashboard(); $event.preventDefault(); $event.stopPropagation()"
            matTooltip="Switch Dashboard">

            <mat-icon>
                {{ showSetDashboard ? 'swap_horiz' : 'swap_horiz' }}
            </mat-icon>
            

        </button>

    </div>

    <!-- SET COUNTS -->
    <table
        *ngIf="showSetDashboard"
        class="table table-borderless table-sm">

        <tr>
            <td width="70%">Current Status :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.currentStatus}}
            </td>
        </tr>

        <tr>
            <td width="70%">Total Sets :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.totalSets}}
            </td>
        </tr>

        <tr>
            <td width="70%">In Progress Sets :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.inProgressSets}}
            </td>
        </tr>

        <tr>
            <td width="70%">Completed Sets :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.completedSets}}
            </td>
        </tr>

        <tr>
            <td width="70%">Failed Sets :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.failedSets}}
            </td>
        </tr>

        <tr>
            <td width="70%">Remaining Sets :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.remainingSets}}
            </td>
        </tr>

    </table>

    <!-- CASE COUNTS -->
    <table
        *ngIf="!showSetDashboard"
        class="table table-borderless table-sm">

        <tr>
            <td width="70%">Current Status :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.currentStatus}}
            </td>
        </tr>

        <tr>
            <td width="70%">Total Cases :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.totalCases}}
            </td>
        </tr>

        <tr>
            <td>In Progress Cases :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.casesInProgress}}
            </td>
        </tr>

        <tr>
            <td>Completed Cases :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.casesCompleted}}
            </td>
        </tr>

        <tr>
            <td>Failed Cases :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.casesFailed}}
            </td>
        </tr>

        <tr>
            <td>Remaining Cases :</td>
            <td style="text-align:right;font-weight:600">
                {{dashboardCounts.casesRemaining}}
            </td>
        </tr>

    </table>

    <app-common-button label="Download" title="Download Summary Report" icon="fas fa-download example-icon"
            [critical]="true" [buttonId]="1111" width="110px" (clicked)="Download()"
            style="margin-left: 6px; margin-right: 6px">
          </app-common-button>

</div>




</div>
  </form>

</div>
          </mat-expansion-panel>

          <div *ngIf="csvToSql">
            <div
              style="
                overflow-x: hidden;
                border-left: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-bottom: 1px solid #a9a9a9a8;
                padding: 15px;
                margin-bottom: 1%;
                padding-top: 3%;
              "
            >
              <form novalidate [formGroup]="FormValidCsv">
                <div class="row">
                  <div class="col-lg-2"></div>
                  <div class="col-lg-4">
                    <div style="display: flex">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMshoppingcomplexchooseimage"
                          >Choose File</mat-label
                        >
                        <input
                          matInput
                          class="file-path validate"
                          type="text"
                          maxlength="250"
                          placeholder="Choose File"
                          formControlName="imageName"
                          id="imageName"
                          [(ngModel)]="statevaluechange.fileName"
                          readonly
                        />
                      </mat-form-field>
                      <div class="file-field" style="width: 20%">
                        <a class="btn-floating btn-sm m-0 float-right">
                          <em
                            class="fas fa-paperclip mt-0"
                            style="text-rendering: auto; color: black"
                          ></em>
                          <input
                            type="file"
                            id="imageupload"
                            name="imageupload"
                            (change)="imagePhotofunction($event, 'zip')"
                            formControlName="imageupload"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-4"
                    style="text-align: center; padding-right: 30px"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >Enter Database Name</mat-label
                      >
                      <input
                        matInput
                        type="text"
                        placeholder="Enter Database Name"
                        formControlName="databasename"
                        [(ngModel)]="statevaluechange.databasename"
                        maxlength="100"
                        required
                      />
                      <mat-error
                        *ngFor="
                          let validation of validation_messages.databasename
                        "
                      >
                        <span
                          *ngIf="
                            FormValidCsv.get('databasename').hasError(
                              validation.type
                            ) &&
                            (FormValidCsv.get('databasename').dirty ||
                              FormValidCsv.get('databasename').touched)
                          "
                        >
                          {{ validation.message }}
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2"></div>
                </div>
                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4" style="text-align: center">
                    <button
                      i18n="@@TMRunButton"
                      type="button"
                      (click)="uploadZipFile()"
                      [style.background-color]="buttonColor"
                      class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    >
                      Upload
                    </button>
                  </div>
                  <div class="col-lg-4"></div>
                </div>
               
              </form>
            </div>
            <ag-grid-angular
              style="height: 305px"
              class="ag-theme-balham"
              [columnDefs]="columnDefsForcsvtosql"
              [animateRows]="true"
              [pagination]="true"
              [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true"
              [rowHeight]="35"
              [headerHeight]="35"
              [enableRangeSelection]="true"
              [debug]="true"
              [rowClassRules]="rowClassRules"
              [components]="components"
              (gridReady)="onGridReadyForLog($event)"
              [hidden]="!true"
            >
            </ag-grid-angular>
   
          </div>

          <!-- R3XML to MySQL tool code. Implemneted by kalpesh on 29-jul-22 -->
          <div *ngIf="R3xmltoMySQL">
            <div
              style="
                overflow-x: hidden;
                border-left: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-bottom: 1px solid #a9a9a9a8;
                padding: 15px;
                margin-bottom: 1%;
                padding-top: 3%;
              "
            >
              <form novalidate [formGroup]="FormValidCsv">
                <div class="row">
                  <div class="col-lg-1"></div>
                  <div class="col-lg-4">
                    <div style="display: flex">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMshoppingcomplexchooseimage"
                          >Choose File
                        </mat-label>
                        <input
                          matInput
                          class="file-path validate"
                          type="text"
                          maxlength="250"
                          placeholder="Choose File"
                          formControlName="imageName"
                          id="imageName"
                          [(ngModel)]="statevaluechange.fileName"
                          readonly
                        />
                      </mat-form-field>
                      <div class="file-field" style="width: 20%">
                        <a class="btn-floating btn-sm m-0 float-right">
                          <em
                            class="fas fa-paperclip mt-0"
                            style="text-rendering: auto; color: black"
                          ></em>
                          <input
                            type="file"
                            id="imageupload"
                            name="imageupload"
                            (change)="imagePhotofunction($event, 'zip')"
                            formControlName="imageupload"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-4"
                    style="text-align: center; padding-right: 30px"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >Enter Database Name</mat-label
                      >
                      <input
                        matInput
                        type="text"
                        placeholder="Enter Database Name"
                        formControlName="databasename"
                        [(ngModel)]="statevaluechange.databasename"
                        maxlength="100"
                        required
                      />
                      <mat-error
                        *ngFor="
                          let validation of validation_messages.databasename
                        "
                      >
                        <span
                          *ngIf="
                            FormValidCsv.get('databasename').hasError(
                              validation.type
                            ) &&
                            (FormValidCsv.get('databasename').dirty ||
                              FormValidCsv.get('databasename').touched)
                          "
                        >
                          {{ validation.message }}
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-2" style="padding-top: 10px">
                    <mat-checkbox
                      formControlName="isSplited"
                      ngDefaultControl
                      [(ngModel)]="isSplited"
                      class="mat-checkbox-layout"
                      style="padding-top: 5px"
                    ></mat-checkbox>
                    <span> is XML splitted? </span>
                  </div>
                  <div class="col-lg-1"></div>
                </div>
                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4" style="text-align: center">
                    <button
                      i18n="@@TMRunButton"
                      type="button"
                      (click)="uploadZipFile()"
                      [style.background-color]="buttonColor"
                      class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    >
                      Upload
                    </button>
                  </div>
                  <div class="col-lg-4"></div>
                </div>
              </form>
            </div>
            <ag-grid-angular
              style="height: 305px"
              class="ag-theme-balham"
              [columnDefs]="columnDefsForR3XMLtoMySQL"
              [animateRows]="true"
              [pagination]="true"
              [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true"
              [rowHeight]="35"
              [headerHeight]="35"
              [enableRangeSelection]="true"
              [debug]="true"
              [rowClassRules]="rowClassRules"
              [components]="components"
              (gridReady)="onGridReadyForLog($event)"
              [hidden]="!true"
            >
            </ag-grid-angular>
          </div>

          <div *ngIf="xmlcase">
            <div
              style="
                overflow-x: hidden;
                border-left: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-bottom: 1px solid #a9a9a9a8;
                padding: 15px;
                margin-bottom: 1%;
                padding-top: 3%;
              "
            >
              <form novalidate [formGroup]="FormValidCsv">
                <div class="row">
                  <div class="col-lg-2"></div>
                  <div class="col-lg-4">
                    <div style="display: flex">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMshoppingcomplexchooseimage"
                          >Choose File</mat-label
                        >
                        <input
                          matInput
                          class="file-path validate"
                          type="text"
                          maxlength="250"
                          placeholder="Choose File"
                          formControlName="imageName"
                          id="imageName"
                          [(ngModel)]="statevaluechange.fileName"
                          readonly
                        />
                      </mat-form-field>
                      <div class="file-field" style="width: 20%">
                        <a class="btn-floating btn-sm m-0 float-right">
                          <em
                            class="fas fa-paperclip mt-0"
                            style="text-rendering: auto; color: black"
                          ></em>
                          <input
                            type="file"
                            id="imageupload"
                            name="imageupload"
                            (change)="imagePhotofunction($event, 'zip')"
                            formControlName="imageupload"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-4"
                    style="text-align: center; padding-right: 30px"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >Enter Database Name</mat-label
                      >
                      <input
                        matInput
                        type="text"
                        placeholder="Enter Database Name"
                        formControlName="databasename"
                        [(ngModel)]="statevaluechange.databasename"
                        maxlength="100"
                        required
                      />
                      <mat-error
                        *ngFor="
                          let validation of validation_messages.databasename
                        "
                      >
                        <span
                          *ngIf="
                            FormValidCsv.get('databasename').hasError(
                              validation.type
                            ) &&
                            (FormValidCsv.get('databasename').dirty ||
                              FormValidCsv.get('databasename').touched)
                          "
                        >
                          {{ validation.message }}
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-2"></div>
                </div>
                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4" style="text-align: center">
                    <button
                      i18n="@@TMRunButton"
                      type="button"
                      (click)="uploadZipFile()"
                      [style.background-color]="buttonColor"
                      class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    >
                      Upload
                    </button>
                  </div>
                  <div class="col-lg-4"></div>
                </div>
              </form>
            </div>
            <ag-grid-angular
              style="height: 305px"
              class="ag-theme-balham"
              [columnDefs]="columnDefsForxmlsplitter"
              [animateRows]="true"
              [pagination]="true"
              [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true"
              [rowHeight]="35"
              [headerHeight]="35"
              [enableRangeSelection]="true"
              [debug]="true"
              [rowClassRules]="rowClassRules"
              [components]="components"
              (gridReady)="onGridReadyForLog($event)"
              [hidden]="!true"
            >
            </ag-grid-angular>
          </div>

          <div *ngIf="xmlsplitter">
            <div
              style="
                overflow-x: hidden;
                border-left: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-bottom: 1px solid #a9a9a9a8;
                padding: 15px;
                margin-bottom: 1%;
                padding-top: 3%;
              "
            >
              <form novalidate [formGroup]="FormValidCsv">
                <div class="row">
                  <div class="col-lg-2"></div>
                  <div class="col-lg-4">
                    <div style="display: flex">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMshoppingcomplexchooseimage"
                          >Choose File
                        </mat-label>
                        <input
                          matInput
                          class="file-path validate"
                          type="text"
                          maxlength="250"
                          placeholder="Choose File"
                          formControlName="imageName"
                          id="imageName"
                          [(ngModel)]="statevaluechange.fileName"
                          readonly
                        />
                      </mat-form-field>

                      <div class="file-field" style="width: 20%">
                        <a class="btn-floating btn-sm m-0 float-right">
                          <em
                            class="fas fa-paperclip mt-0"
                            style="text-rendering: auto; color: black"
                          ></em>
                          <input
                            type="file"
                            id="imageupload"
                            name="imageupload"
                            (change)="imagePhotofunction($event, 'zip')"
                            formControlName="imageupload"
                          />
                        </a>
                      </div>
                    </div>

                    <div class="xmlcheckbox" *ngIf="radiobutton">
                      <mat-radio-group>
                        <mat-radio-button
                          style="font-size: medium"
                          value="R2XML"
                          (click)="select('R2XML')"
                          >R2XML</mat-radio-button
                        >
                        <mat-radio-button
                          style="font-size: medium; margin-left: 25px"
                          value="R3XML"
                          (click)="select('R3XML')"
                          >R3XML</mat-radio-button
                        >
                      </mat-radio-group>
                    </div>
                  </div>
               
                  <div
                    class="col-2"
                    *ngIf="csvsplitter"
                    style="text-align: center"
                  >
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@TMSTAFFMASTERfirstname"
                        >No of Record</mat-label
                      >
                      <input
                        matInput
                        type="text"
                        placeholder="record per page"
                        formControlName="databasename"
                        formControlName="noOfRecord"
                        id="noOfRecord"
                        [(ngModel)]="statevaluechange.noOfRecord"
                        required
                      />
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4"></div>
                </div>
                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4" style="text-align: center">
                    <button
                      i18n="@@TMRunButton"
                      type="button"
                      (click)="uploadZipFile()"
                      [style.background-color]="buttonColor"
                      class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    >
                      Upload
                    </button>
                  </div>
                  <div class="col-lg-4"></div>
                </div>
              </form>
            </div>
            <ag-grid-angular
              style="height: 305px"
              class="ag-theme-balham"
              [columnDefs]="columnDefsForxmlsplitter"
              [animateRows]="true"
              [pagination]="true"
              [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true"
              [rowHeight]="35"
              [headerHeight]="35"
              [enableRangeSelection]="true"
              [debug]="true"
              [rowClassRules]="rowClassRules"
              [components]="components"
              (gridReady)="onGridReadyForLog($event)"
              [hidden]="!true"
            >
            </ag-grid-angular>
          </div>

          <!-- R3xmlExtraction code starts -->
          <div *ngIf="R3xmlExtraction">
            <div
              style="
                overflow-x: hidden;
                border-left: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-bottom: 1px solid #a9a9a9a8;
                padding: 15px;
                margin-bottom: 1%;
                padding-top: 3%;
              "
            >
              <form novalidate [formGroup]="FormValidR3Extractor">
                <div class="row">
                  <div class="col-lg-2"></div>
                  <div class="col-lg-4">
                    <div style="display: flex">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMshoppingcomplexchooseimage"
                          >Choose File</mat-label
                        >
                        <input
                          matInput
                          class="file-path validate"
                          type="text"
                          maxlength="250"
                          placeholder="Choose File"
                          formControlName="imageName"
                          id="imageName"
                          [(ngModel)]="statevaluechange.fileName"
                          readonly
                        />
                      </mat-form-field>

                      <div class="file-field" style="width: 20%">
                        <a class="btn-floating btn-sm m-0 float-right">
                          <em
                            class="fas fa-paperclip mt-0"
                            style="text-rendering: auto; color: black"
                          ></em>
                          <input
                            type="file"
                            id="imageupload"
                            name="imageupload"
                            (change)="imagePhotofunctionR3($event)"
                            formControlName="imageupload"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4"></div>
                </div>
                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4" style="text-align: center">
                    <button
                      i18n="@@TMRunButton"
                      type="button"
                      (click)="uploadR3Csvfile()"
                      [style.background-color]="buttonColor"
                      class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    >
                      Upload
                    </button>
                  </div>
                  <div class="col-lg-4"></div>
                </div>
              </form>
            </div>
            <ag-grid-angular
              style="height: 305px"
              class="ag-theme-balham"
              [columnDefs]="columnDefsForR3Extractor"
              [animateRows]="true"
              [pagination]="true"
              [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true"
              [rowHeight]="35"
              [headerHeight]="35"
              [enableRangeSelection]="true"
              [debug]="true"
              [rowClassRules]="rowClassRules"
              [components]="components"
              (gridReady)="onGridReadyForR3Extractor($event)"
              [hidden]="!true"
            >
            </ag-grid-angular>
          </div>

          <!-- R3xmlExtraction code ends -->

          <!-- Added validation for R3xmlextraction -->
          <div
            *ngIf="
              !caseState &&
              !xmlcase &&
              !csvToSql &&
              !xmlsplitter &&
              !producttypeupdate &&
              !R3xmlExtraction &&
              !R3xmltoMySQL &&
              !dataExtractorTool &&
              !oracleToExcelToFtp
            "
          >
            <div
              *ngIf="
                !csvToSql == true &&
                caseState == false &&
                xmlcase == false &&
                producttypeupdate == false
              "
            >
              <div
                style="
                  overflow-x: hidden;
                  border-left: 1px solid #a9a9a9a8;
                  border-right: 1px solid #a9a9a9a8;
                  border-bottom: 1px solid #a9a9a9a8;
                  padding: 15px;
                  margin-bottom: 1%;
                  padding-top: 3%;
                "
              >
                <form novalidate [formGroup]="validations_path_form">
                  <div class="row">
                    <div
                      class="col-6"
                      style="text-align: center; padding-left: 35px"
                    >
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERfirstname"
                          >Enter Source Folder Path</mat-label
                        >
                        <input
                          matInput
                          type="text"
                          placeholder="Enter Source Folder Path"
                          formControlName="sourceFolder"
                          [(ngModel)]="toolDescriptionModel.sourceFolder"
                          maxlength="100"
                          required
                        />
                        <mat-error
                          *ngFor="
                            let validation of validation_messages.sourceFolder
                          "
                        >
                          <span
                            *ngIf="
                              validations_path_form
                                .get('sourceFolder')
                                .hasError(validation.type) &&
                              (validations_path_form.get('sourceFolder')
                                .dirty ||
                                validations_path_form.get('sourceFolder')
                                  .touched)
                            "
                          >
                            {{ validation.message }}
                          </span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div
                      class="col-6"
                      style="text-align: center; padding-right: 30px"
                    >
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMSTAFFMASTERfirstname"
                          >Enter Destination Folder Path</mat-label
                        >
                        <input
                          matInput
                          type="text"
                          placeholder="Enter Destination Folder Path"
                          formControlName="destFolder"
                          [(ngModel)]="toolDescriptionModel.destFolder"
                          maxlength="100"
                          required
                        />
                        <mat-error
                          *ngFor="
                            let validation of validation_messages.destFolder
                          "
                        >
                          <span
                            *ngIf="
                              validations_path_form
                                .get('destFolder')
                                .hasError(validation.type) &&
                              (validations_path_form.get('destFolder').dirty ||
                                validations_path_form.get('destFolder').touched)
                            "
                          >
                            {{ validation.message }}
                          </span>
                        </mat-error>
                      </mat-form-field>
                    </div>
                    <div class="col-2">
                      <button
                        i18n="@@TMRunButton"
                        type="button"
                        class="pathButton"
                        [disabled]="!validations_path_form.valid"
                        (click)="save()"
                        [style.background-color]="buttonColor"
                        class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                        style="
                          padding: 0.3rem 1.6rem;
                          font-size: 0.85rem;
                          width: 100%;
                          margin-left: 29.5vw;
                          margin-right: 30vw;
                          margin-top: 4px;
                        "
                      id="115">
                        Run
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <ag-grid-angular
              style="height: 305px"
              class="ag-theme-balham"
              [columnDefs]="columnDefsForLog"
              [animateRows]="true"
              [pagination]="true"
              [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true"
              [rowHeight]="35"
              [headerHeight]="35"
              [enableRangeSelection]="true"
              [debug]="true"
              [rowClassRules]="rowClassRules"
              [components]="components"
              (gridReady)="onGridReadyForLog($event)"
              [hidden]="!true"
            >
            </ag-grid-angular>
          </div>
          <div *ngIf="caseState">
            <div
              style="
                overflow-x: hidden;
                border-left: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-bottom: 1px solid #a9a9a9a8;
                padding: 15px;
                margin-bottom: 1%;
                padding-top: 3%;
              "
            >
              <form novalidate [formGroup]="FormValid">
                <div class="row">
                  <div class="col-lg-4">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFormulaexpression"
                        >Object Names</mat-label
                      >
                      <mat-select
                        (selectionChange)="selectedObjectlabel($event)"
                        [(ngModel)]="selectedObjectName"
                        formControlName="objectName"
                        required
                      >
                        <mat-option>None</mat-option>
                        <mat-option
                          *ngFor="let objectName of objectNames"
                          [value]="objectName.objectname"
                        >
                          {{ objectName.objectlabel }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngFor="
                          let validation of validation_messages.objectName
                        "
                      >
                        <span
                          *ngIf="
                            FormValid.get('objectName').hasError(
                              validation.type
                            ) &&
                            (FormValid.get('objectName').dirty ||
                              FormValid.get('objectName').touched)
                          "
                        >
                          {{ validation.message }}
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <div style="display: flex">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMshoppingcomplexchooseimage"
                          >Choose File</mat-label
                        >
                        <input
                          matInput
                          class="file-path validate"
                          type="text"
                          maxlength="250"
                          placeholder="Choose File"
                          formControlName="imageName"
                          id="imageName"
                          [(ngModel)]="statevaluechange.fileName"
                          readonly
                        />
                      </mat-form-field>
                      <div class="file-field" style="width: 20%">
                        <a class="btn-floating btn-sm m-0 float-right">
                          <em
                            class="fas fa-paperclip mt-0"
                            style="text-rendering: auto; color: black"
                          ></em>

                          <input
                            type="file"
                            id="imageupload"
                            name="imageupload"
                            (change)="imagePhotofunctionState($event)"
                            formControlName="imageupload"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-4">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFormulaexpression">Action</mat-label>
                      <mat-select
                        (selectionChange)="lookUpType($event)"
                        [(ngModel)]="selectedCompanyid"
                        formControlName="action"
                        required
                      >
                        <mat-option>None</mat-option>
                        <mat-option
                          *ngFor="let eachGroup of actionDetails"
                          [value]="eachGroup"
                        >
                          {{ eachGroup.lable }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngFor="let validation of validation_messages.action"
                      >
                        <span
                          *ngIf="
                            FormValid.get('action').hasError(validation.type) &&
                            (FormValid.get('action').dirty ||
                              FormValid.get('action').touched)
                          "
                        >
                          {{ validation.message }}
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4" style="text-align: center">
                    <button
                      i18n="@@TMRunButton"
                      type="button"
                      (click)="uploadFileToActivity()"
                      [style.background-color]="buttonColor"
                      class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    >
                      Upload
                    </button>
                  </div>
                  <div class="col-lg-4"></div>
                </div>
               
              </form>
            </div>

            <ag-grid-angular
              style="height: 243px"
              class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForState"
              [animateRows]="true"
              [pagination]="true"
              [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true"
              [rowHeight]="35"
              [headerHeight]="35"
              [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45"
              [paginationPageSize]="paginationPageSize"
              [paginationNumberFormatter]="paginationNumberFormatter"
              [enableRangeSelection]="true"
              [debug]="true"
              [rowClassRules]="rowClassRules"
              (paginationChanged)="onPaginationChanged()"
              [components]="components"
              (gridReady)="onGridReadyStateChange($event, 10)"
              [hidden]="!true"
            >
            </ag-grid-angular>
          </div>

          <div *ngIf="producttypeupdate">
            <div
              style="
                overflow-x: hidden;
                border-left: 1px solid #a9a9a9a8;
                border-right: 1px solid #a9a9a9a8;
                border-bottom: 1px solid #a9a9a9a8;
                padding: 15px;
                margin-bottom: 1%;
                padding-top: 3%;
              "
            >
              <form novalidate [formGroup]="FormValidProductType">
                <div class="row">
                  <div class="col-lg-2"></div>
                  <div class="col-lg-4">
                    <mat-form-field appearance="outline">
                      <mat-label i18n="@@RCFormulaexpression"
                        >Object Names</mat-label
                      >
                      <mat-select
                        (selectionChange)="selectedObjectlabel($event)"
                        [(ngModel)]="selectedObjectName"
                        formControlName="objectName"
                        required
                      >
                        <mat-option>None</mat-option>
                        <mat-option
                          *ngFor="let objectName of objectNames"
                          [value]="objectName.objectname"
                        >
                          {{ objectName.objectlabel }}
                        </mat-option>
                      </mat-select>
                      <mat-error
                        *ngFor="
                          let validation of validation_messages.objectName
                        "
                      >
                        <span
                          *ngIf="
                            FormValidProductType.get('objectName').hasError(
                              validation.type
                            ) &&
                            (FormValidProductType.get('objectName').dirty ||
                              FormValidProductType.get('objectName').touched)
                          "
                        >
                          {{ validation.message }}
                        </span>
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="col-lg-4">
                    <div style="display: flex">
                      <mat-form-field appearance="outline">
                        <mat-label i18n="@@TMshoppingcomplexchooseimage"
                          >Choose File</mat-label
                        >
                        <input
                          matInput
                          class="file-path validate"
                          type="text"
                          maxlength="250"
                          placeholder="Choose File"
                          formControlName="imageName"
                          id="imageName"
                          [(ngModel)]="statevaluechange.fileName"
                          readonly
                        />
                      </mat-form-field>
                      <div class="file-field" style="width: 20%">
                        <a class="btn-floating btn-sm m-0 float-right">
                          <em
                            class="fas fa-paperclip mt-0"
                            style="text-rendering: auto; color: black"
                          ></em>
                          <input
                            type="file"
                            id="imageupload"
                            name="imageupload"
                            (change)="imagePhotofunction($event, '')"
                            formControlName="imageupload"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2"></div>
                </div>
                <div class="row">
                  <div class="col-lg-4"></div>
                  <div class="col-lg-4" style="text-align: center">
                    <button
                      i18n="@@TMRunButton"
                      type="button"
                      (click)="updateproducttype()"
                      [style.background-color]="buttonColor"
                      class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                    >
                      Upload
                    </button>
                  </div>
                  <div class="col-lg-4"></div>
                </div>
              
              </form>
            </div>

            <ag-grid-angular
              style="height: 243px"
              class="ag-theme-balham table-width tablestyles square scroolbar-dusty-grass square thin"
              [columnDefs]="columnDefsForState"
              [animateRows]="true"
              [pagination]="true"
              [defaultColDef]="defaultColDef"
              [suppressPaginationPanel]="true"
              [rowHeight]="35"
              [headerHeight]="35"
              [enableBrowserTooltips]="true"
              [floatingFiltersHeight]="45"
              [paginationPageSize]="paginationPageSize"
              [paginationNumberFormatter]="paginationNumberFormatter"
              [enableRangeSelection]="true"
              [debug]="true"
              [rowClassRules]="rowClassRules"
              (paginationChanged)="onPaginationChanged()"
              [components]="components"
              (gridReady)="onGridReadyProductTypeChange($event, 11)"
              [hidden]="!true"
            >
            </ag-grid-angular>
          </div>



          <!-- /* Modified by Renuka on 10-04-2026 
          Added Data Extractor Tool */ -->
<div *ngIf="dataExtractorTool">
  <div
    style="
      overflow-x:hidden;
      border-left:1px solid #a9a9a9a8;
      border-right:1px solid #a9a9a9a8;
      border-bottom:1px solid #a9a9a9a8;
      padding:15px;
      margin-bottom:1%;
      padding-top:3%;
    ">

    <form novalidate [formGroup]="FormValidCaseAudit"></form>
 </div>

 <ag-grid-angular
    style="height:305px"
    class="ag-theme-balham"
    [columnDefs]="dataExtractor"
    [animateRows]="true"
    [pagination]="true"
    [defaultColDef]="defaultColDef"
    [paginationPageSize]="dataExtractorPaginationPageSize"
    [suppressPaginationPanel]="false"
    [rowHeight]="35"
    [headerHeight]="35"
    [enableRangeSelection]="true"
    [rowClassRules]="rowClassRules"
    [components]="components"
    (gridReady)="onGridReadyForLog($event)">
  </ag-grid-angular>
  
</div>




          <!-- /* Modified by Renuka on 22-04-2026 
          Added Oracle To FTP Tool */ -->
<div *ngIf="oracleToExcelToFtp">

<div
style="
overflow-x:hidden;
border-left:1px solid #a9a9a9a8;
border-right:1px solid #a9a9a9a8;
border-bottom:1px solid #a9a9a9a8;
padding:15px;
margin-bottom:1%;
padding-top:3%;
"
>

<form [formGroup]="FormValidOracle">

<div class="row">

<div class="col-lg-2"></div>

<!-- Set Id -->
<div class="col-lg-4">

  <mat-form-field appearance="outline" style="width:100%">
    <mat-label>Set Id</mat-label>

    <input
      matInput
      formControlName="setId"
      placeholder="Enter Set Id"
    />

    <mat-error *ngIf="FormValidOracle.get('setId').invalid && 
      (FormValidOracle.get('setId').dirty || FormValidOracle.get('setId').touched)">
      Valid Set Id is required
    </mat-error>

  </mat-form-field>

</div>

<div class="col-lg-4">

  <div style="display:flex">

    <mat-form-field appearance="outline" style="width:100%">

      <mat-label>Choose Excel File</mat-label>

      <input
        matInput
        formControlName="imageName"
        [(ngModel)]="statevaluechange.fileName"
        readonly
      />

      <mat-error *ngIf="FormValidOracle.get('imageName').invalid &&
        (FormValidOracle.get('imageName').dirty || FormValidOracle.get('imageName').touched)">
        Please choose a file
      </mat-error>
    </mat-form-field>

    <div class="file-field" style="width:20%">

      <a class="btn-floating btn-sm">

        <em class="fas fa-paperclip"></em>

        <input
          type="file"
          accept=".xls,.xlsx"
          (change)="uploadOracleFile($event)"
          formControlName="imageupload"
        />

      </a>

    </div>

  </div>

</div>
</div>
<div class="row">

<div class="col-lg-4"></div>
<div class="col-lg-4" style="display:flex; align-items:flex-end; justify-content:center;">

  <app-common-button label="Upload" title="Upload" [critical]="true"
                    [buttonId]="114" width="110px" (clicked)="uploadOracleData()"
                    style="margin-left: 6px; margin-right: 6px">
                </app-common-button>

</div>
<div class="col-lg-4"></div>


</div>

</form>

</div>

<ag-grid-angular
  style="height:305px"
  class="ag-theme-balham"
  [columnDefs]="oracleColumns"
  [animateRows]="true"
  [pagination]="true"
  [defaultColDef]="defaultColDef"
  [paginationPageSize]="dataExtractorPaginationPageSize"
  [suppressPaginationPanel]="false"
  [enableBrowserTooltips]="true"
  [rowHeight]="35"
  [headerHeight]="35"
  [enableRangeSelection]="true"
  [debug]="true"
  [rowClassRules]="rowClassRules"
  [components]="components"
  (gridReady)="onGridReadyForLog($event)"
>
</ag-grid-angular>

</div>





        </div>
      </div>
    </div>
  </div>
</div>